import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

function* createMemberList() {
  yield takeEvery(actions.CREATE_MEMBER_LIST, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'post'], `${API_HOST}/api/memberList`, data);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_LIST_END });
    }
  });
}

function* searchMemberLists() {
  yield takeEvery(actions.SEARCH_MEMBER_LISTS, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call([axios, 'get'], `${API_HOST}/api/memberList?${parameters.toString()}`);
      yield put({ type: actions.SEARCH_MEMBER_LISTS_END });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_LISTS_END });
    }
  });
}

function* deleteMemberLists() {
  yield takeEvery(actions.DELETE_MEMBER_LISTS, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call([axios, 'delete'], `${API_HOST}/api/memberList`, { data });
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_LISTS_END });
    }
  });
}

function* createMemberListBatch() {
  yield takeEvery(actions.CREATE_MEMBER_LIST_BATCH, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'post'],
        `${API_HOST}/api/memberList/batch`,
        data,
        { timeout: 300000 }, // 5 minutes
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.CREATE_MEMBER_LIST_BATCH_END });
    }
  });
}

function* searchMemberListBatch() {
  yield takeEvery(actions.SEARCH_MEMBER_LIST_BATCH, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberList/batch?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_LIST_BATCH_END });
    }
  });
}

function* deleteMemberListBatch() {
  yield takeEvery(actions.DELETE_MEMBER_LIST_BATCH, function* (action) {
    const { data, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'delete'],
        `${API_HOST}/api/memberList/batch`,
        { data },
        { timeout: 300000 }, // 5 minute
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.DELETE_MEMBER_LIST_BATCH_END });
    }
  });
}

function* searchMemberListBatchRow() {
  yield takeEvery(actions.SEARCH_MEMBER_LIST_BATCH_ROW, function* (action) {
    const { parameters, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${API_HOST}/api/memberList/batch/row?${parameters.toString()}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.SEARCH_MEMBER_LIST_BATCH_ROW_END });
    }
  });
}

function* getMemberListStatusOfProgress() {
  yield takeEvery(actions.GET_MEMBER_LIST_STATUS_OF_PROGRESS, function* (action) {
    try {
      const { id, onSuccess } = action;
      const res = yield call([axios, 'get'], `${API_HOST}/api/memberList/${id}/progress`);
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.GET_MEMBER_LIST_STATUS_OF_PROGRESS_END });
    }
  });
}

export default function* rootSaga() {
  yield all([
    fork(createMemberList),
    fork(searchMemberLists),
    fork(deleteMemberLists),
    fork(createMemberListBatch),
    fork(searchMemberListBatch),
    fork(deleteMemberListBatch),
    fork(searchMemberListBatchRow),
    fork(getMemberListStatusOfProgress),
  ]);
}
